export default __webpack_public_path__ + "static/media/noe-display-bold-italic.67482ca7.woff2";